<template>
<v-card flat :class="{'pa-2':$vuetify.breakpoint.smAndUp}" @mouseover="hover=true" @mouseleave="hover=false" height="100%">
    <v-card-title>
        <div class="d-flex align-center">
            <img :src="item.logo" height="48px" width="auto">
            <div class="px-2 distribution-card-title">
                {{ item.name }}
            </div>
        </div>
        <v-spacer></v-spacer>
        <v-icon class="pa-2 icon-edit" v-show="hover" color="#5A8DEE" @click="emitEdit()">edit</v-icon>
    </v-card-title>
    <v-card-text>
        <div class="pt-1" v-html="description" />
        <!-- <v-divider></v-divider> -->
        <slot name="footer"></slot>
    </v-card-text>
    <v-card-actions class="pa-0 ma-0">
        <slot name="left-action"></slot>
        <v-spacer />
        <v-btn text @click="emitEdit()">
            <v-icon size="32" color="green" v-if="item.connected">link</v-icon>
            <v-icon size="32" color="red" v-else>link_off</v-icon>
            <span class="pr-2 green--text" v-if="item.connected">{{ $t('distribution.card.connected') }}</span>
            <span class="pr-2 red--text" v-else>{{ $t('distribution.card.not_connected') }}</span>
        </v-btn>
    </v-card-actions>

</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
export default {

    props: {
        item: Object,
    },
    components: {},

    data() {
        return {
            rate_plans: [],
            to_be_saved: [],
            hover: false,
            description: "",
        }
    },

    watch: {
        'item.slug': {
            handler() {
                this.getDescription();
            }
        },
    },

    created() {
        this.getDescription();
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        getDescription() {
            if(!this.item.slug) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/translations/pages?app_slug=juvo-console&fields[]=slug&search=distribution.short." + this.item.slug;


            this.$axios.get(endpoint)
                .then(response => {
                    this.description = response.data.data[0].translations.body.ro;
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },
        emitEdit() {
            this.$emit('edit')
        }

    },
}
</script>
